import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { connect } from 'react-redux';
import { reportSipReady } from '../api/vbsbc.js';
import { Inviter, SessionState, UserAgent } from "sip.js";

const WaitingCallPage = ({ phone, dispatch }) => {
  const [phoneSession, setPhoneSession] = useState(null);
  const navigate = useNavigate();

  const performDialAction = async () => {
    const { connInfo, userAgent } = phone;
    const target = UserAgent.makeURI(`sip:${connInfo.taskDestination}@${connInfo.sipDomain}`);
    const inviter = new Inviter(userAgent, target, {
      sessionDescriptionHandlerOptions: {
        constraints: { audio: true, video: false }
      }
    });
    setPhoneSession(inviter);
    inviter.stateChange.addListener((state) => {
      console.log(`[Outgoing] State changed to ${state}.`);
      switch (state) {
        case SessionState.Initial:
          break;
        case SessionState.Establishing:
          break;
        case SessionState.Established:
          setupRemoteMedia(inviter);
          break;
        case SessionState.Terminating:
        case SessionState.Terminated:
          cleanupMedia();
          break;
        default:
          throw new Error("Unknown session state.");
      }
    });
    // navigator.getUserMedia(
    //   { audio: true, video: false },
    //   (stream) => {
    //     console.log('ok');
    //   },
    //   (err) => {
    //     console.error(`The following error occurred: ${err.name}`);
    //   },
    // );
    await inviter.invite();
    console.log('Invite completed');
  };

  const setupRemoteMedia = (session) => {
    const remoteStream = new MediaStream();
    session.sessionDescriptionHandler.peerConnection.getReceivers().forEach((receiver) => {
      if (receiver.track) {
        remoteStream.addTrack(receiver.track);
      }
    });
    let mediaElement = document.getElementById('remote-audio-track');
    mediaElement.srcObject = remoteStream;
    mediaElement.play();
  }

  const cleanupMedia = () => {
    let mediaElement = document.getElementById('remote-audio-track');
    mediaElement.srcObject = null;
    mediaElement.pause();
    navigate('/hangup', { replace: true });
  }

  const reportReadySipPhone = async () => {
    const { connInfo } = phone;
    console.log('connInfo', connInfo);
    const { reportUrl, username, sipDomain, reportNonce } = connInfo;
    if (!reportUrl) {
      navigate('/auth?loadFromStorage=true', { replace: true });
      return;
    }
    // report
    await reportSipReady({ reportUrl, username, sipDomain, reportNonce });

    // if task is dial
    if (connInfo.task === 'dial') {
      performDialAction();
    }
  }
  useEffect(() => {
    reportReadySipPhone();
  }, []);

  const hangupCall = () => {
    phoneSession.bye();
  };

  return (
    <div className="flex flex-col justify-start items-stretch">
      <div className="p-3 text-center font-xs">You're connected.</div>
      <div className="p-3 flex flex-row justify-center items-start">
        <button
          type="button"
          onClick={() => hangupCall()}
          className="inline-flex w-full justify-center rounded-md bg-green-500 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-green-600 sm:ml-3 sm:w-auto">
          Hangup
        </button>
      </div>
      <audio id="remote-audio-track" style={{ display: 'none' }}></audio>
    </div>
  );
};

export default connect(({
  phone
}) => ({
  phone
}))(WaitingCallPage);
